import tw from "twin.macro";
import { styled } from "~/config/stitches";

const AroundInput = styled("div", {
  ...tw`relative rounded-md`,
});

export { AroundInput };
